import { Component, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { OnboardingService } from 'src/app/shared/service/onboarding.service';
import { OnboardingHRDetail } from 'src/app/shared/models/OnboardingHRDetail';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortHeader, MatSort, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
//import * as jspdf from 'jspdf';
//import html2canvas from 'html2canvas';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { EmployeeService } from '../../shared/service/employee.service';
import { WinHRPagesUserMapping } from '../../shared/models/WinHRPagesUserMapping ';
import { WinHRPagesUserList } from '../../shared/models/WinHRPagesUserList';
import { UserService } from '../../shared/service/user.service';

@Component({
  selector: 'app-hr-permission-list',
  templateUrl: './hr-permission-list.component.html',
  styleUrls: ['./hr-permission-list.component.css']
})
export class HrPermissionListComponent implements OnInit {
  displayedColumns: string[] = ['Employee Code', 'Employee Name', 'Pages To Access', 'Edit', 'Delete'];
  @ViewChild(MatPaginator, { static: false }) paginatorFTE: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortFTE: MatSort;
  check: boolean = false;
  exampl: any;
  result: any;
  empList: OnboardingHRDetail[];

  error: string;
  dataSourceFTE: any;
  locationsList: any[];
  permission: any;
  editEnable: boolean = false;
  deleteEnable: boolean = false;
  constructor(private _service: EmployeeService, public router: Router, public dialog: MatDialog, private toastr: ToastrService, public _userService: UserService) {
    this.empList = [];
    this.dataSourceFTE = new MatTableDataSource;
  }
  ngOnInit() {
    this.getUserMappings();
    this.permission = this._userService.userInfo.permissions.find(i => i.Menu === 'Permissions');
    if (this.permission.HasFullAccess || this.permission.EditingPermission)
      this.editEnable = true;
    if (this.permission.HasFullAccess || this.permission.DeletingPermission) {
      this.deleteEnable = true
    }
  }


  getUserMappings() {
    this._service.getAllUserMappings().subscribe((data: WinHRPagesUserList[]) => {
      this.dataSourceFTE.data = data;
      this.dataSourceFTE.paginator = this.paginatorFTE;
      this.dataSourceFTE.sort = this.sortFTE;
    }, error => this.error = error);

    }
  applyFilter(filterValue: string) {
    this.dataSourceFTE.filter = filterValue.trim().toLowerCase();
  }

  editEmployee(empCode) {
    this.router.navigateByUrl("/addpermissions/" + empCode);
  }
  deleteEmployee(empCode) {
    const message = `Are you sure you want to delete?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this._service.deleteEmpPermissions(empCode).subscribe(data => {
          this.toastr.success("Deleted successfully");
          this.getUserMappings();
        },
          error => this.error = error
        );
      }
    }, error => { this.result = error; });

  }



}
